import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: [],
  error: null,
  initialLoad: false,
  loading: false,
  saving: false,
};

const deleteSingleTimesheetRequestSuccess = (state, payload) => {
  const data = [...state.data].filter((t) => t.id !== payload.data.id);
  return {
    data,
    error: null,
    loading: false,
    saving: false,
  };
};

const getTimesheetsRequest = (state) => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getTimesheetsRequestFailure = (state, action) => {
  return {
    ...state,
    error: action.error,
    loading: false,
  };
};
const getTimesheetsRequestSuccess = (state, payload) => {
  return {
    ...state,
    data: [...payload.data],
    error: null,
    initialLoad: true,
    loading: false,
  };
};

export default handleActions(
  {
    [types.DELETE_SINGLE_TIMESHEET_REQUEST_SUCCESS]: deleteSingleTimesheetRequestSuccess,
    [types.GET_TIMESHEETS_REQUEST]: getTimesheetsRequest,
    [types.GET_TIMESHEETS_REQUEST_FAILURE]: getTimesheetsRequestFailure,
    [types.GET_TIMESHEETS_REQUEST_SUCCESS]: getTimesheetsRequestSuccess,
  },
  initialState
);
